import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

export const DefaultContainedButton = ({
  color = "secondary",
  fullWidth = true,
  height = 56,
  borderColor = "secondary.main",
  fontWeight = 500,
  text = "로그인",
  onClick,
}) => {
  return (
    <Button
      variant="contained"
      fullWidth={fullWidth}
      color={color}
      onClick={(e) => onClick(e)}
      sx={{
        boxShadow: 0,
        borderRadius: "8px",
        height: height,
        fontWeight: fontWeight,
        border: 1,
        borderColor: borderColor,
        "&:hover": {
          boxShadow: 0,
        },
      }}
    >
      {text}
    </Button>
  );
};

export const DefaultOutlinedButton = ({
  color = "secondary",
  fullWidth = true,
  height = 56,
  borderColor = "secondary.main",
  fontWeight = 500,
  text = "로그인",
  onClick,
}) => {
  return (
    <Button
      variant="outlined"
      fullWidth={fullWidth}
      color={color}
      onClick={(e) => onClick(e)}
      sx={{
        boxShadow: 0,
        borderRadius: "8px",
        height: height,
        fontWeight: fontWeight,
        border: 1,
        borderColor: borderColor,
        "&:hover": {
          boxShadow: 0,
        },
      }}
    >
      {text}
    </Button>
  );
};

export const PrimaryLightButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.dark,
  backgroundColor: theme.palette.primary.light,
  boxShadow: 0,
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    boxShadow: 0,
  },
}));

export const GreyLightButton = styled(Button)(({ theme }) => ({
  color: theme.palette.grey[800],
  backgroundColor: theme.palette.grey[400],
  boxShadow: 0,
  borderRadius: "21px",
  "&:hover": {
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.grey[800],
    boxShadow: 0,
    borderRadius: "21px",
  },
}));
